import { Input } from "antd/es";
import _ from "lodash";
import React, { PureComponent } from "react";
import NumberFormat, { NumberFormatProps } from "react-number-format";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common-props";

declare let window: any;
interface NumericboxProps extends NumberFormatProps {
  onChange: any;
  symbolPosition: "left" | "right";
  step?: number;
}

interface NumericboxState {}

class Percent extends PureComponent<NumericboxProps & CommonProps, NumericboxState> {
  constructor(props: NumericboxProps) {
    super(props);
    this.state = {};
  }

  getProps = () => {
    const props: any = _.clone(this.props);
    let style: any = _.clone(this.props.style);
    if (!style) {
      style = {
        width: "100%"
      };
      props.style = style;
    } else if (!style.width) {
      style.width = "100%";
      props.style = style;
    }

    if (props.onChange) {
      delete props.onChange;
    }
    if (props.symbolPosition) {
      delete props.symbolPosition;
    }
    if (props.step !== undefined) {
      delete props.step;
    }
    if (props.value && typeof props.value === "object") {
      let tmp;
      if (props.value.floatValue !== undefined) {
        tmp = props.value.floatValue;
      } else if (props.value.value !== undefined) {
        tmp = props.value.value;
      } else {
        tmp = props.value;
      }
      delete props.value;
      props.value = tmp;
    }
    return props;
  };

  onChange = (value: number | any) => {
    if (this.props.onChange) {
      let newValue: number;
      if (value && typeof value === "object") {
        if (value.floatValue !== undefined) {
          newValue = value.floatValue;
        } else if (value.value !== undefined && value.value !== "") {
          newValue = value.value;
        } else if (value.value === "" || value.floatValue === null) {
          newValue = 0;
        } else {
          newValue = 0;
        }
      } else if (value === "" || value === null || value === undefined) {
        newValue = 0;
      } else {
        newValue = value;
      }
      this.props.onChange(newValue);
    }
  };

  getCurrentValue = (): number => {
    const { value } = this.props;
    if (value && typeof value === "object") {
      if ((value as any).floatValue !== undefined) {
        return (value as any).floatValue;
      }
      if ((value as any).value !== undefined) {
        return Number((value as any).value) || 0;
      }
    }
    if (typeof value === "string") {
      return parseFloat(value) || 0;
    }
    return (value as number) || 0;
  };

  onKeyDown = (e: React.KeyboardEvent) => {
    if (this.props.step === undefined) return;
    if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;

    e.preventDefault();
    const step = this.props.step;
    const currentValue = this.getCurrentValue();
    const newValue = e.key === "ArrowUp" ? Math.min(100, currentValue + step) : Math.max(0, currentValue - step);

    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
  };

  getSuffix = () => {
    if (this.props.symbolPosition == undefined || this.props.symbolPosition == "right") {
      return "%";
    }
    return undefined;
  };

  getPrefix = () => {
    if (this.props.symbolPosition == "left") {
      return "%";
    }
    return undefined;
  };

  render(): React.ReactNode {
    const MAX_VAL = 100;
    const MIN_VAL = 0;
    const withValueLimit = ({ floatValue, value }) => {
      // Allow empty strings and undefined/null values
      if (value === "" || floatValue == undefined || floatValue == null) {
        return true;
      }
      // Allow values within range including 0
      return floatValue <= MAX_VAL && floatValue >= MIN_VAL;
    };
    if (this.props.value && typeof this.props.value === "string" && window.kuika?.dashboardState === 1) {
      return <Input value={this.props.value} style={this.props.style} />;
    }
    return (
      <NumberFormat
        {...this.getProps()}
        customInput={Input}
        onValueChange={this.onChange}
        onKeyDown={this.onKeyDown}
        isAllowed={withValueLimit}
        suffix={this.getSuffix()}
        prefix={this.getPrefix()}
      />
    );
  }
}

const percent = withCommonEvents(Percent);
export { percent as Percent };
